export default "__VITE_ASSET__CzJcJK9z__"